import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  Dropdown,
  DateRangeDropdown,
  DateRangeSelection
} from '@contrast-security-inc/design-system-inputs'
import { css } from '@emotion/css'

const useRangeTypes = () => {
  const intl = useIntl()

  const rangeTypes = [
    {
      id: 'LAST_SEEN',
      name: intl.formatMessage({ id: 'title_ttrTimeFilter_lastSeen' })
    },
    {
      id: 'DISCOVERED',
      name: intl.formatMessage({ id: 'title_ttrTimeFilter_discovered' })
    },
    {
      id: 'CLOSED',
      name: intl.formatMessage({ id: 'title_ttrTimeFilter_closed' })
    }
  ]

  return { rangeTypes }
}
export function TtrRangeTypeDropdown({
  onOptionSelect,
  selectedType: initSelectedType
}) {
  const label = useIntl().formatMessage({
    id: 'title_ttrTimeFilter_filterType'
  })
  const { rangeTypes } = useRangeTypes()
  const [selectedType, setSelectedType] = useState(initSelectedType)
  const onChange = (event) => {
    const option = event.target.value.id
    setSelectedType(option)
    onOptionSelect(option)
  }

  return (
    <Dropdown
      aria-label={label}
      label={label}
      itemToID={(it) => it?.id}
      itemToString={(it) => it?.name}
      items={rangeTypes}
      className={css`
        > div:nth-child(2) {
          z-index: 1000;
        }
      `}
      data-testid={'ttr-type-dropdown-test-id'}
      onChange={onChange}
      value={rangeTypes.find((it) => it.id === selectedType)}
    />
  )
}
export const reactTtrRangeTypeDropdown = createNgReactBridgeDirective(
  'reactTtrRangeTypeDropdown',
  [],
  TtrRangeTypeDropdown,
  ['onOptionSelect', 'selectedType']
)

export function TtrDateRangeDropdown({
  onDateRangeOptionSelect,
  selectedDateRange: initSelectedDateRange
}) {
  const intl = useIntl()
  const [selectedDateRange, setSelectedDateRange] =
    useState<DateRangeSelection>(initSelectedDateRange)
  const onChangeRange = (dateRangeOption: DateRangeSelection) => {
    setSelectedDateRange(dateRangeOption)
    onDateRangeOptionSelect(dateRangeOption)
  }

  return (
    <DateRangeDropdown
      items={[
        {
          label: intl.formatMessage({ id: 'title_allTime' }),
          type: 'CUSTOM_OPTION'
        },
        {
          count: 30,
          unit: 'DAYS',
          type: 'RELATIVE_TO_NOW'
        },
        {
          count: 6,
          unit: 'MONTHS',
          type: 'RELATIVE_TO_NOW'
        },
        {
          count: 12,
          unit: 'MONTHS',
          type: 'RELATIVE_TO_NOW'
        },
        {
          type: 'CUSTOM_DATE_RANGE'
        }
      ]}
      label={intl.formatMessage({
        id: 'title_dashboard_selectTimeRange'
      })}
      inputHeight={35}
      className={css`
        > div:nth-child(2) {
          z-index: 1000;
        }
      `}
      wrapCustomDateRange={false}
      data-testid={'ttr-date-filter-dropdown-test-id'}
      onChangeRange={onChangeRange}
      selectedRange={selectedDateRange}
    />
  )
}

export const reactTtrDateRangeDropdown = createNgReactBridgeDirective(
  'reactTtrDateRangeDropdown',
  [],
  TtrDateRangeDropdown,
  ['onDateRangeOptionSelect', 'selectedDateRange']
)
